export const getBaseFileName = (fileName) => {
    const indexOfIngestionId = fileName.indexOf('__file_ingestion_id__');
    return indexOfIngestionId <= 0 ? fileName : fileName.substring(0, indexOfIngestionId);
}